import React from 'react';
import AmbassadorPage from 'pages/AmbassadorPage/AmbassadorPage';

const Ambassador = () => {
    return (
        <AmbassadorPage/>
    );
};

export default Ambassador;